import { render } from "./TipoVariavelSelecao.vue?vue&type=template&id=d708f1ac&scoped=true&ts=true"
import script from "./TipoVariavelSelecao.vue?vue&type=script&lang=ts"
export * from "./TipoVariavelSelecao.vue?vue&type=script&lang=ts"

import "./TipoVariavelSelecao.vue?vue&type=style&index=0&id=d708f1ac&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d708f1ac"]])

export default __exports__